import { ChatMap, ChatsGetters, MessageMap } from './types'

const getters: ChatsGetters = {
  getChats({ chats }): ChatMap {
    return chats
  },
  getMessages({ messages }): MessageMap {
    return messages
  },
}

export default getters
